export default __webpack_public_path__ + "static/media/Optin 1.65f1ec8e.mp3";